import Vue from 'vue'
import Element from 'element-ui'
import '../theme/index.css'

Vue.use(Element)
